    <div class="community-gr-card-container pb-3 px-3 container-shadow" 
        [ngStyle]="{'background-image': 'linear-gradient(to bottom,' + (community?.attributes?.background_color || '#B1CBCF') + ' 0%, #FFFFFF 97%)' }">
        <div class="paragraph-bold ellipsis mb-3 pt-3">
            <span class="color-grey-700">{{community?.attributes?.text}}</span>
        </div>
        <div class="separator-margin"></div>
        <div class="banner-sm d-flex d-sm-none">
            <img loading="lazy" class="banner-sm__banner" 
                [src]="community?.media_list[0]?.media_url" 
                onerror="this.src='assets/themes/images/single-community-placeholder.svg'"  
                alt="community banner" 
                (click)="navigateToDetail()"
                />
        </div>
        <div class="content-container d-flex justify-content-between" 
            [ngClass]="{'align-items-center': !(community?.promotional_text || community?.description)}">
            <div class="content">
                <div class="container__title cursor-pointer heading-4 mb-2"
                    [title]="community?.title" 
                    (click)="navigateToDetail()">
                    {{community?.title}}
                </div>
                <div class="container__description" 
                    *ngIf="(community?.promotional_text || community?.description)">
                    <span *ngIf="!more">
                        <span *ngIf="community?.description">
                            <span class="secondary-paragraph-bold">{{mls.languageText.community.key154}}: </span><span class="secondary-paragraph"><span class="color-grey-700">{{community?.description | textTruncate: numbers.ONE_FORTY_EIGHT}}</span></span></span>
                        <span *ngIf="community?.promotional_text" class="secondary-paragraph">
                            <span class="color-grey-700">{{community?.promotional_text | textTruncate : numbers.ONE_SEVENTY}}</span>
                        </span>
                    </span>
                    <span class="more" *ngIf="more">
                        <span *ngIf="community?.description">
                            <span class="secondary-paragraph-bold">{{mls.languageText.community.key154}}: </span>
                            <span class="secondary-paragraph"><span class="color-grey-700">{{community?.promotional_text || community?.description}}</span>
                            </span>
                        </span>
                    </span>
                    <span class="secondary-paragraph-bold cursor-pointer" 
                        *ngIf="isReadMoreEnable && !more" (click)="more = !more"><span>{{mls.languageText.community.key155}}</span></span>
                    <span class="secondary-paragraph cursor-pointer" 
                    *ngIf="isReadMoreEnable && more" (click)="more = !more"><span class="color-grey-500">...{{mls.languageText.community.key156}}</span></span>
                </div>
                <div class="container__specialty secondary-paragraph text-left">
                    <ng-container *ngFor="let speciality of community?.specialities">
                        <span class="color-grey-500 mr-2">#{{speciality.speciality_name}}</span>
                    </ng-container>
                </div>
            </div>
            <div class="banner d-none d-sm-block">
                <img loading="lazy" class="banner__banner cursor-pointer" 
                    [src]="community?.media_list[0]?.media_url" 
                    onerror="this.src='assets/themes/images/single-community-placeholder.svg'"  
                    alt="community banner" 
                    (click)="navigateToDetail()"
                    />
            </div>
        </div>
        <div class="container__conten-info d-flex align-items-center mr-2 mb-4 mt-4" 
            [ngClass]="{'mtb-8px': !(community?.promotional_text || community?.description)}">
            <span class="ellipsis secondary-paragraph"><span class="color-grey-700">{{createdByText()}}</span></span>
            <span class="slash-grey-500"></span>
            <span class="content-container__privacy">
                <img loading="lazy" src="assets/themes/icons/{{getCommunityType()}}-community-icon.svg" width="16" height="16"
                alt="privacy icon" class="privacy-icon"/>
            </span>
        </div>
        <div class="btn-container mt-3" 
            [ngClass]="{'d-flex justify-content-between': !community?.flags?.show_join_button}">
            <div class="btn-design medium filled" 
                (click)="joinCommunity()" 
                *ngIf="community?.flags?.show_join_button; else viewCTA">
                <img src="assets/themes/icons/primary-loader.gif" 
                    width="20" 
                    height="20"
                    class="cursor-pointer"
                    *ngIf="loading"
                    alt="loader"/>
                <span *ngIf="!loading" 
                    class="ellipsis">{{ctaText}}
                </span>
            </div>
            <ng-template #viewCTA>
                <div class="btn-design medium filled w-60 view-community mr-3" 
                    (click)="navigateToDetail()" >
                    {{mls.languageText.community.key152}}
                </div>
                <div class="btn-design medium w-40 outline" (click)="shareProduct()">
                    <img class="share-icon mr-2" 
                        src="assets/themes/icons/share.svg" 
                        alt="Share"/>
                    <span class="share-txt">{{mls.languageText.community.key153}}</span>
                </div>
            </ng-template>
        </div>
    </div>
    
    <app-confirm-modal
        [isWithdrawRequestConfirmModalShown]="confirmationModal"
        [confirmationModalContent]="confirmationText"
        [getListItem]="confirmedCommunity"
        (resetConfirmModal)="resetConfirmModal()"
        (emitAllowAction)="allowAction($event)">
    </app-confirm-modal>